import { render, staticRenderFns } from "./UserAbsencesRequests.vue?vue&type=template&id=1c675a26&"
import script from "./UserAbsencesRequests.vue?vue&type=script&lang=js&"
export * from "./UserAbsencesRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports